import { Deserializer } from 'jsonapi-serializer';
import { request, useQuery } from '@applyboard/ui-utils';
import { z } from 'zod';

const leadSourcesResponseSchema = z.array(
  z.object({
    displayName: z.string(),
    name: z.string(),
    id: z.string(),
  }),
);

export interface LeadSource {
  displayName: string;
  name: string;
  id: string;
}

export function useLeadSources(filterByRole = true) {
  const { isLoading, isSuccess, isFetching, error, data } = useQuery(
    ['leadSources', { pkg: 'ab-student-intake-form' }],
    async () =>
      await request(`/api/v2/lead_sources?filter_by_role=${filterByRole}`, {
        schema: leadSourcesResponseSchema,
        deserializer: new Deserializer({
          keyForAttribute: 'camelCase',
        }),
      }),
  );

  return {
    isLoadingLeadSources: isLoading,
    isFetchingLeadSources: isFetching,
    leadSourcesError: error,
    leadSources: isSuccess ? data : [],
  };
}

export function useAllLeadSources() {
  return useLeadSources(false);
}
